import React from 'react';
import { Link } from 'react-router-dom';
import { W37LoadNotice } from './W37LoadNotice';

// A bad optional detail must not unmount the entire application's React root.
export class W37ErrorBoundary extends React.Component {
  state = { failed: false, version: 0 };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('Window 37 could not render', error, info.componentStack);
  }

  retry = () => this.setState(state => ({ failed: false, version: state.version + 1 }));

  render() {
    if (this.state.failed) {
      return (
        <main className="min-h-screen bg-amber-50/40 px-4 py-8" data-testid="w37-render-error-page">
          <div className="mx-auto max-w-3xl space-y-6">
            <h1 className="text-2xl font-bold text-slate-900" data-testid="w37-render-error-title">Window 37</h1>
            <W37LoadNotice scope="render" message="Pose details could not be displayed. Your saved data has not been changed." onRetry={this.retry} />
            <Link to="/" className="inline-block text-sm font-semibold text-amber-800 underline" data-testid="w37-render-error-back">Back to dashboard</Link>
          </div>
        </main>
      );
    }
    return <React.Fragment key={this.state.version}>{this.props.children}</React.Fragment>;
  }
}
